/* eslint-disable jira/filename-case */
import type { PopupProps } from '@atlaskit/popup/types';
import { Popup } from '@atlaskit/popup';
import { withChoreographedToggle } from '@jira/platform__choreographer-services/src/main.tsx';
import type { ChoreographedComponentProps } from '@jira/platform__choreographer-services/src/types.tsx';

export const ChoreographerPopup: {
	(props: PopupProps & ChoreographedComponentProps): React.JSX.Element;
	displayName: string;
} = withChoreographedToggle<PopupProps>(Popup, 'isOpen', 'content');
